import TopBarOptions from "./TopBarOptions";
import SearchBar from "./SearchBar";

import { styled } from "@mui/material/styles";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import Box from "@mui/material/Box";
// eslint-disable-next-line
import MuiAppBar, { AppBarProps as muiAppBarProps } from "@mui/material/AppBar";
import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

interface AppBarProps extends muiAppBarProps {
    open?: boolean;
    width: number;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open, width }) => ({
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: width,
        width: `calc(100% - ${width}px)`,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
}));

interface TopBarProps {
    toggleDrawer: () => void;
    drawerWidth: number;
    open?: boolean;
}

const TopBar: React.FC<TopBarProps> = ({ toggleDrawer, open, drawerWidth }) => {
    const [searchParams] = useSearchParams();
    const q = searchParams.get("q") || "";
    const [searchValue, setSearchValue] = useState(q);
    const navigate = useNavigate();

    // Update search value when query changes
    useEffect(() => {
        setSearchValue(q);
    }, [q]);

    function handleSearch(value: string) {
        navigate(`/forum/search?q=${value}`);
    }

    return (
        <AppBar position="absolute" open={open} width={drawerWidth}>
            <Toolbar
                sx={{
                    pr: "24px", // keep right padding when drawer closed
                }}
            >
                <IconButton
                    edge="start"
                    color="inherit"
                    aria-label="open drawer"
                    onClick={toggleDrawer}
                    sx={{
                        marginRight: "36px",
                        ...(open && { display: "none" }),
                    }}
                >
                    <MenuIcon />
                </IconButton>
                <SearchBar value={searchValue} onValueChange={setSearchValue} onSearch={handleSearch} />
                <Box width={250} marginLeft={2}>
                    <TopBarOptions />
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default TopBar;
